module.exports = __webpack_public_path__ + "static/img/Carl_Wilhelm_Vallgren.493d743.jpg";